import { useContext, useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import { GeneralContext } from '../../../context/generalContext';
import classes from './MenuRestaurantsDropdown.module.scss';
import iconDown from '../../../images/icon-down.png';
import selectedIcon from '../../../images/icon-selected.png';
import { addressesAPI } from '../../../services/GeneralService';

Modal.setAppElement('#root');

export default function MenuRestaurantsDropdown() {
  const { activeCity, setActiveCity, selectedAddress, setSelectedAddress, windowWidth, activeLanguage } =
    useContext(GeneralContext);
  const { data: addresses } = addressesAPI.useFetchAllAddressesQuery();

  const [dropdown, setDropdown] = useState(false);
  const toggleModal = () => {
    setDropdown(!dropdown);
  };

  // заморозить область за модальным если оно открыто
  useEffect(() => {
    if (window.innerWidth <= 767) {
      if (dropdown) {
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
      } else {
        document.body.style.overflow = 'visible';
        document.body.style.position = '';
      }
    }
  }, [dropdown]);

  const ref = useRef();

  useEffect(() => {
    const handler = event => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false);
      }
      if (dropdown && event.target.tagName === 'BUTTON') {
        setDropdown(prev => !prev);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [dropdown]);

  const [addressesInCity, setAddressesInCity] = useState([]);
  useEffect(() => {
    if (addresses) {
      setAddressesInCity(
        addresses?.filter(
          address =>
            address.cityId === activeCity && address.id !== 44618 && address.id !== 42434 && address.id !== 41169,
        ),
      );
    }
  }, [activeCity, addresses]);

  const changeAddress = id => {
    setSelectedAddress(id);
    setActiveCity(addresses?.filter(address => address.id === id)[0]?.cityId);
  };

  return (
    <div className={classes.menuRestaurantsDropdown}>
      {windowWidth > 767 && (
        <>
          <button
            className={classes.dropdownBtn}
            type='button'
            aria-haspopup='menu'
            aria-expanded={dropdown ? 'true' : 'false'}
            onClick={() => setDropdown(prev => !prev)}
          >
            <p>
              {activeLanguage === 1
                ? addresses?.find(restaurant => restaurant.id === selectedAddress)?.shortDescr
                : addresses?.find(restaurant => restaurant.id === selectedAddress)?.shortDescr_en ||
                  addresses?.find(restaurant => restaurant.id === selectedAddress)?.shortDescr}
            </p>
            <img src={iconDown} alt='arrow down' className={classes.dropdownIcon} />
          </button>

          <ul className={`${classes.dropdown} ${dropdown ? `${classes.show}` : ''}`} ref={ref}>
            {addressesInCity.map(restaurant => (
              <Link
                key={restaurant.id}
                to={
                  window.location.pathname.split('/').slice(-2).slice(0, 1)[0] === 'menu' ||
                  window.location.pathname.split('/').slice(-2).slice(0, 1)[0] === 'beer'
                    ? `${window.location.pathname}/${
                        addresses?.filter(address => address.id === restaurant.id)[0]?.slug
                      }`
                    : `${window.location.pathname.split('/').slice(0, -1).join('/')}/${
                        addresses?.filter(address => address.id === restaurant.id)[0]?.slug
                      }`
                }
              >
                <li
                  onClick={() => {
                    setDropdown(false);
                    changeAddress(restaurant.id);
                  }}
                  className={`${classes.dropdownItem} ${
                    selectedAddress === restaurant.id ? `${classes.dropdownItemActive}` : ''
                  }`}
                >
                  {activeLanguage === 1 ? restaurant?.shortDescr : restaurant?.shortDescr_en || restaurant?.shortDescr}
                </li>
              </Link>
            ))}
          </ul>
        </>
      )}

      {windowWidth <= 767 && (
        <>
          <button className={classes.dropdownBtn} type='button' onClick={() => setDropdown(prev => !prev)}>
            <p>
              {activeLanguage === 1
                ? addresses?.find(restaurant => restaurant.id === selectedAddress)?.shortDescr
                : addresses?.find(restaurant => restaurant.id === selectedAddress)?.shortDescr_en ||
                  addresses?.find(restaurant => restaurant.id === selectedAddress)?.shortDescr}
            </p>
            <img src={iconDown} alt='arrow down' className={classes.dropdownIcon} />
          </button>

          <Modal
            isOpen={dropdown}
            onRequestClose={toggleModal}
            contentLabel='My dialog'
            className={classes.modal}
            overlayClassName={classes.overlay}
          >
            <div className={classes.title}>{activeLanguage === 1 ? 'Выберите ресторан' : 'Choose the restaraunt'}</div>
            <ul className={classes.list}>
              {addressesInCity.map(item => (
                <Link
                  key={item.id}
                  to={
                    window.location.pathname.split('/').slice(-2).slice(0, 1)[0] === 'menu' ||
                    window.location.pathname.split('/').slice(-2).slice(0, 1)[0] === 'beer'
                      ? `${window.location.pathname}/${addresses?.filter(address => address.id === item.id)[0]?.slug}`
                      : `${window.location.pathname.split('/').slice(0, -1).join('/')}/${
                          addresses?.filter(address => address.id === item.id)[0]?.slug
                        }`
                  }
                  // className={`${classes.listItem} ${(selectedAddress === item.id) ? `${classes.listItemActive}` : ''}`}
                  className={classes.listItemLink}
                >
                  <div
                    key={item.id}
                    onClick={() => {
                      toggleModal();
                      changeAddress(item.id);
                    }}
                    className={`${classes.listItem} ${selectedAddress === item.id ? `${classes.listItemActive}` : ''}`}
                  >
                    {item.shortDescr ? (
                      <span>{activeLanguage === 1 ? item.shortDescr : item.shortDescr_en || item.shortDescr}</span>
                    ) : (
                      <span>{activeLanguage === 1 ? item.name : item.name_en || item.name}</span>
                    )}
                    <img src={selectedIcon} alt='selected icon' />
                  </div>
                </Link>
              ))}
            </ul>
          </Modal>
        </>
      )}
    </div>
  );
}
